import { createEvent, createStore } from 'effector'

import en from '@portal/i18n/data/en.json'

import type { I18n, Language } from './lib/types'

export const $i18n = createStore<I18n>({ lang: 'en', i18n: en })
export const $lang = $i18n.map(({ lang }) => lang)

export const langSelected = createEvent<Language>()
export const langUpdated = createEvent<I18n>()

$i18n.on(langUpdated, (_, i18n) => i18n)
